/**
 * i18n dictionary for Kupidon REBORN — full translations for 5 CIS languages.
 * Fallback chain: current lang -> Russian -> key.
 */
export const LANGS = [
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "kk", label: "Қазақша", flag: "🇰🇿" },
  { code: "be", label: "Беларуская", flag: "🇧🇾" },
  { code: "uz", label: "O'zbekcha", flag: "🇺🇿" },
  { code: "ky", label: "Кыргызча", flag: "🇰🇬" },
];

export const COUNTRIES = [
  { code: "ru", label: "Россия" },
  { code: "kz", label: "Казахстан" },
  { code: "by", label: "Беларусь" },
  { code: "uz", label: "Узбекистан" },
  { code: "kg", label: "Кыргызстан" },
];

const D = {
  ru: {
    app_name: "Kupidon REBORN",
    tagline_1: "Найди своё",
    tagline_hl: "«взаимно»",
    tagline_2: "рядом.",
    hero_sub: "Знакомства в Telegram по-новому. Тёплые люди, честные фото, никакой сухой ленты.",
    continue_telegram: "Продолжить через Telegram",
    demo_start: "Войти как гость",
    outside_tg: "Открыто вне Telegram — доступен демо-режим.",
    onboard_title: "Расскажи о себе",
    onboard_hint: "Это увидят другие пользователи.",
    first_name: "Имя",
    first_name_ph: "Ваше имя",
    age: "Возраст",
    i_am: "Я",
    male: "Мужчина",
    female: "Женщина",
    looking_for: "Ищу",
    guys: "Парней",
    girls: "Девушек",
    any: "Любых",
    where: "Где ты?",
    where_hint: "Мы покажем людей рядом с тобой.",
    country: "Страна",
    city: "Город",
    city_ph: "Москва / Астана / Ташкент…",
    language: "Язык",
    location_title: "Точная геолокация",
    location_granted: "✓ Разрешено. Мы найдём людей рядом.",
    location_ask: "Разреши доступ, чтобы видеть ближайших.",
    location_asking: "Запрос…",
    location_allow: "Разрешить",
    bio_step_title: "Пара слов о себе",
    bio_step_hint: "Кратко и от души. До 300 символов.",
    bio_ph: "Например: люблю путешествия, кофе, и хорошие книги…",
    next: "Далее",
    finish: "Готово",
    saving: "Сохраняем…",
    step_photos_kicker: "Шаг 2",
    photos_title: "Твои фото",
    photos_hint_a: "Загрузи 1–5 фото. Чем больше у тебя — тем больше чужих ты видишь ",
    photos_hint_b: "без размытия.",
    photos_max: "Максимум 5 фото",
    photo_add: "Добавить",
    photo_uploading: "Загружаем…",
    photo_main: "Главное",
    upload_toast: "Загружаем и проверяем…",
    photo_added: "Фото добавлено!",
    photo_upload_error: "Ошибка загрузки",
    photo_delete_error: "Не удалось удалить",
    photo_need_one: "Нужно хотя бы одно фото",
    to_app: "В приложение",
    photos_progress: "{count} из 5 фото загружено",
    discover_kicker: "Знакомства",
    discover_title: "Рядом с тобой",
    no_more_title: "Пока никого рядом",
    no_more_sub: "Загляни чуть позже — новые люди появляются каждый час.",
    refresh: "Обновить",
    unlock_more_photos: "Загрузи ещё фото, чтобы увидеть все",
    stamp_like: "ЛАЙК",
    stamp_nope: "НЕТ",
    daily_limit: "Дневной лимит лайков исчерпан. Оформи Премиум!",
    match_title: "Это взаимно!",
    match_you_liked: "{me}, вы понравились {them}",
    match_you_liked_short: "Вы понравились {them}",
    match_send_msg: "Написать сообщение",
    match_keep: "Смотреть дальше",
    matches_kicker: "Симпатии",
    matches_title: "Твои мэтчи",
    matches_empty_title: "Пока нет симпатий",
    matches_empty_sub: "Ставь лайки в ленте — когда взаимно, они появятся здесь.",
    say_hi: "Скажи «привет»",
    new_message_hint: "Новое сообщение…",
    chat_start: "Начните диалог. Скажите «привет» 👋",
    chat_input_ph: "Напиши сообщение…",
    telegram_sent_label: "Отправлен Telegram",
    telegram_hidden: "Профиль скрыт",
    typing: "печатает…",
    share_tg_title: "Отправить свой Telegram?",
    share_tg_desc: "Собеседник получит ссылку на ваш @{u}. Продолжить?",
    cancel: "Отмена",
    send: "Отправить",
    tg_sent_toast: "Telegram отправлен!",
    tg_send_error: "Не удалось отправить",
    no_tg_username: "У вас нет @username в Telegram",
    profile_photos: "Фотографии",
    profile_photos_count: "{n} из 5 загружено",
    profile_manage: "Управлять",
    profile_bio: "О себе",
    profile_save: "Сохранить",
    profile_saved: "Профиль обновлён",
    profile_photos_pill: "фото",
    profile_super_pill: "⭐ лайков",
    profile_tier: "тариф",
    premium_title: "Купидон Премиум",
    premium_desc: "Безлимитные лайки, суперлайки и просмотр @username твоих мэтчей.",
    premium_cta: "Оформить (demo)",
    premium_activated: "Премиум активирован (demo)",
    logout: "Выйти",
    error_generic: "Что-то пошло не так. Попробуй ещё раз.",
    loading: "Загружаем…",
    km_short: "км",
    name_required: "Введите имя",
    age_range: "Возраст 18–100",
    city_required: "Укажите город",
    profile_created: "Профиль создан!",
    hi: "Привет",
    geo_unavailable: "Геолокация недоступна",
    geo_skip: "Продолжим без геолокации — можно включить позже.",
    tg_only_or_demo: "Откройте приложение внутри Telegram или используйте демо-режим.",
    open_in_tg: "Открыть в Telegram",
    err_load_feed: "Не удалось загрузить ленту",
    err_open_chat: "Не удалось открыть чат",
    err_send: "Не отправилось",
    story_title: "История на 24 часа",
    story_hint: "Один снимок — покажем его всем на день.",
    story_add: "Добавить",
    story_active: "Активна ещё {h} ч",
    story_uploading: "Загружаем историю…",
    story_posted: "История опубликована!",
    story_deleted: "История удалена",
    story_none: "У пользователя нет активной истории",
    story_hint_video: "Фото или короткое видео до 5 секунд — покажем на день.",
    story_video_too_long: "Видео дольше 5 секунд — обрежьте и попробуйте снова.",
    story_video_too_large: "Файл слишком большой (макс. 8 МБ).",
    profile_location_title: "Геолокация",
    profile_location_desc: "Твоё местоположение видно другим, чтобы находить людей рядом.",
    profile_location_enabled: "Показывать меня рядом",
    profile_location_update: "Обновить геолокацию",
    profile_location_updated: "Геолокация обновлена",
    profile_location_ask: "Разрешить геолокацию",
    profile_location_refreshed: "Местоположение обновлено при входе",
    premium_title: "Kupidon Premium",
    premium_subtitle: "Больше внимания, больше мэтчей",
    premium_tier_days: "{days} дней",
    premium_buy_button: "Купить",
    premium_current_status_free: "Бесплатный тариф",
    premium_current_status_active: "Premium до {date}",
    premium_confirming: "Подтверждаем оплату…",
    premium_success: "Премиум активирован!",
    premium_cancelled: "Оплата отменена",
    premium_failed: "Не удалось оплатить. Попробуйте ещё раз",
    premium_unavailable_outside_telegram: "Оплата доступна только в Telegram",
    premium_benefit_superlikes: "5 суперлайков в день",
    premium_benefit_unlimited_likes: "Лайки без ограничений",
    premium_benefit_likes_received: "Видно, кто вас лайкнул",
    premium_benefit_username: "Виден юзернейм Telegram",
    premium_benefit_badge: "Заметный премиум-значок",
    likes_received_kicker: "Лайкнули вас",
    likes_received_empty: "Пока никто не лайкнул — но это ненадолго",
    likes_received_like_back: "Лайкнуть в ответ",
    matches_tab_matches: "Мэтчи",
    matches_tab_likes: "Лайкнули вас",
  },
  kk: {
    tagline_1: "Өз",
    tagline_hl: "«өзара»-ыңды",
    tagline_2: "жақыннан тап.",
    hero_sub: "Telegram-да таныстық жаңаша: жақын адамдар, шынайы фото, құрғақ лента жоқ.",
    continue_telegram: "Telegram арқылы жалғастыру",
    demo_start: "Қонақ ретінде кіру",
    outside_tg: "Telegram-нан тыс — демо-режим қолжетімді.",
    onboard_title: "Өзің туралы айт",
    onboard_hint: "Мұны басқа қолданушылар көреді.",
    first_name: "Аты",
    first_name_ph: "Атыңыз",
    age: "Жасы",
    i_am: "Мен",
    male: "Ер",
    female: "Әйел",
    looking_for: "Іздеймін",
    guys: "Жігіттер",
    girls: "Қыздар",
    any: "Кез-келген",
    where: "Қайдасың?",
    where_hint: "Жаныңдағы адамдарды көрсетеміз.",
    country: "Ел",
    city: "Қала",
    city_ph: "Алматы / Астана…",
    language: "Тіл",
    location_title: "Дәл геолокация",
    location_granted: "✓ Рұқсат етілді.",
    location_ask: "Жақындағыларды көру үшін рұқсат бер.",
    location_asking: "Сұраныс…",
    location_allow: "Рұқсат ету",
    bio_step_title: "Өзің туралы қысқаша",
    bio_step_hint: "Қысқа әрі жүректен. 300 таңбаға дейін.",
    bio_ph: "Мысалы: саяхатты, кофені жақсы көремін…",
    next: "Келесі",
    finish: "Дайын",
    saving: "Сақтаудамыз…",
    step_photos_kicker: "2-қадам",
    photos_title: "Сенің фотоларың",
    photos_hint_a: "1–5 фото жүкте. Неғұрлым көп болса, соғұрлым басқалардікін ",
    photos_hint_b: "бұлыңғырсыз көресің.",
    photos_max: "Максимум 5 фото",
    photo_add: "Қосу",
    photo_uploading: "Жүктелуде…",
    photo_main: "Басты",
    upload_toast: "Жүктеп тексерудеміз…",
    photo_added: "Фото қосылды!",
    photo_upload_error: "Жүктеу қатесі",
    photo_delete_error: "Жоюға болмады",
    photo_need_one: "Кем дегенде бір фото керек",
    to_app: "Қосымшаға",
    photos_progress: "5-тен {count} фото жүктелді",
    discover_kicker: "Таныстық",
    discover_title: "Сенің жаныңда",
    no_more_title: "Әзірше жақында ешкім жоқ",
    no_more_sub: "Кейінірек қайта кел — жаңа адамдар қосылады.",
    refresh: "Жаңарту",
    unlock_more_photos: "Барлығын көру үшін тағы фото жүкте",
    stamp_like: "ЛАЙК",
    stamp_nope: "ЖОҚ",
    daily_limit: "Күндік лайк лимиті таусылды. Премиум ал!",
    match_title: "Өзара!",
    match_you_liked: "{me}, {them} сені ұнатты",
    match_you_liked_short: "{them} сені ұнатты",
    match_send_msg: "Хабарлама жазу",
    match_keep: "Әрі қарай көру",
    matches_kicker: "Симпатиялар",
    matches_title: "Сенің мэтчтерің",
    matches_empty_title: "Әзірше симпатия жоқ",
    matches_empty_sub: "Лайк қой — өзара болғанда осында пайда болады.",
    say_hi: "«Сәлем» де",
    new_message_hint: "Жаңа хабарлама…",
    chat_start: "Диалог баста. «Сәлем» деп жаз 👋",
    chat_input_ph: "Хабарлама жаз…",
    telegram_sent_label: "Telegram жіберілді",
    telegram_hidden: "Профиль жасырын",
    typing: "жазып жатыр…",
    share_tg_title: "Өзіңнің Telegram-ыңды жіберу?",
    share_tg_desc: "Ол сенің @{u} сілтемеңді алады. Жалғастыру?",
    cancel: "Болдырмау",
    send: "Жіберу",
    tg_sent_toast: "Telegram жіберілді!",
    tg_send_error: "Жіберілмеді",
    no_tg_username: "Telegram-да @username жоқ",
    profile_photos: "Фотолар",
    profile_photos_count: "5-тен {n} жүктелді",
    profile_manage: "Басқару",
    profile_bio: "Өзім туралы",
    profile_save: "Сақтау",
    profile_saved: "Профиль жаңартылды",
    profile_photos_pill: "фото",
    profile_super_pill: "⭐ лайк",
    profile_tier: "тариф",
    premium_title: "Купидон Премиум",
    premium_desc: "Шексіз лайк, суперлайк және мэтчтердің @username-і.",
    premium_cta: "Ресімдеу (demo)",
    premium_activated: "Премиум белсендірілді (demo)",
    logout: "Шығу",
    error_generic: "Қате шықты. Қайталап көр.",
    loading: "Жүктелуде…",
    km_short: "км",
    name_required: "Атыңды енгіз",
    age_range: "Жас 18–100",
    city_required: "Қаланы көрсет",
    profile_created: "Профиль жасалды!",
    hi: "Сәлем",
    geo_unavailable: "Геолокация қолжетімсіз",
    geo_skip: "Геолокациясыз жалғастырамыз — кейін қосуға болады.",
    tg_only_or_demo: "Telegram ішінде аш немесе демо-режимді пайдалан.",
    open_in_tg: "Telegram-да ашу",
    err_load_feed: "Лентаны жүктеу мүмкін болмады",
    err_open_chat: "Чатты ашу мүмкін болмады",
    err_send: "Жіберілмеді",
    story_title: "24 сағаттық стори",
    story_hint: "Бір сурет — бір күнге бәріне көрсетеміз.",
    story_add: "Қосу",
    story_active: "Тағы {h} сағ белсенді",
    story_uploading: "Сторини жүктеудеміз…",
    story_posted: "Стори жарияланды!",
    story_deleted: "Стори жойылды",
    story_none: "Қолданушыда белсенді стори жоқ",
    story_hint_video: "Фото немесе 5 секундқа дейінгі бейне — бір күнге көрсетеміз.",
    story_video_too_long: "Бейне 5 секундтан ұзын — қысқартыңыз.",
    story_video_too_large: "Файл тым үлкен (макс. 8 МБ).",
    profile_location_title: "Геолокация",
    profile_location_desc: "Сенің орналасуың басқаларға көрінеді, жақын адамдарды табу үшін.",
    profile_location_enabled: "Мені жақыннан көрсету",
    profile_location_update: "Геолокацияны жаңарту",
    profile_location_updated: "Геолокация жаңартылды",
    profile_location_ask: "Геолокацияға рұқсат беру",
    profile_location_refreshed: "Орналасу кіру кезінде жаңартылды",
    premium_title: "Kupidon Premium",
    premium_subtitle: "Көбірек назар, көбірек мэтч",
    premium_tier_days: "{days} күн",
    premium_buy_button: "Сатып алу",
    premium_current_status_free: "Тегін тариф",
    premium_current_status_active: "Premium {date} дейін",
    premium_confirming: "Төлем расталуда…",
    premium_success: "Премиум белсендірілді!",
    premium_cancelled: "Төлем тоқтатылды",
    premium_failed: "Төлем өтпеді. Қайта көріңіз",
    premium_unavailable_outside_telegram: "Төлем тек Telegram-да қолжетімді",
    premium_benefit_superlikes: "Күніне 5 суперлайк",
    premium_benefit_unlimited_likes: "Лайктарға шек жоқ",
    premium_benefit_likes_received: "Сізді кім лайк қойғаны көрінеді",
    premium_benefit_username: "Telegram юзернеймі көрінеді",
    premium_benefit_badge: "Ерекшеленген премиум белгісі",
    likes_received_kicker: "Сізді лайк қойғандар",
    likes_received_empty: "Әзірге ешкім лайк қойған жоқ — бұл ұзаққа созылмайды",
    likes_received_like_back: "Жауап лайк қою",
    matches_tab_matches: "Мэтчтер",
    matches_tab_likes: "Сізді лайк қойғандар",
  },
  be: {
    tagline_1: "Знайдзі сваё",
    tagline_hl: "«узаемна»",
    tagline_2: "побач.",
    hero_sub: "Знаёмствы ў Telegram па-новаму. Цёплыя людзі, шчырыя фота, ніякай сухой стужкі.",
    continue_telegram: "Працягнуць праз Telegram",
    demo_start: "Увайсці як госць",
    outside_tg: "Адкрыта па-за Telegram — даступны дэма-рэжым.",
    onboard_title: "Раскажы пра сябе",
    onboard_hint: "Гэта ўбачаць іншыя карыстальнікі.",
    first_name: "Імя",
    first_name_ph: "Ваша імя",
    age: "Узрост",
    i_am: "Я",
    male: "Мужчына",
    female: "Жанчына",
    looking_for: "Шукаю",
    guys: "Хлопцаў",
    girls: "Дзяўчат",
    any: "Любых",
    where: "Дзе ты?",
    where_hint: "Мы пакажам людзей побач.",
    country: "Краіна",
    city: "Горад",
    city_ph: "Мінск / Гродна…",
    language: "Мова",
    location_title: "Дакладная геалакацыя",
    location_granted: "✓ Дазволена.",
    location_ask: "Дазволь доступ, каб бачыць бліжэйшых.",
    location_asking: "Запыт…",
    location_allow: "Дазволіць",
    bio_step_title: "Пара слоў пра сябе",
    bio_step_hint: "Каротка і ад душы. Да 300 сімвалаў.",
    bio_ph: "Напрыклад: люблю падарожжы, каву…",
    next: "Далей",
    finish: "Гатова",
    saving: "Захоўваем…",
    step_photos_kicker: "Крок 2",
    photos_title: "Твае фота",
    photos_hint_a: "Загрузі 1–5 фота. Чым больш у цябе — тым больш чужых бачыш ",
    photos_hint_b: "без размыцця.",
    photos_max: "Максімум 5 фота",
    photo_add: "Дадаць",
    photo_uploading: "Загружаем…",
    photo_main: "Галоўнае",
    upload_toast: "Загружаем і правяраем…",
    photo_added: "Фота дададзена!",
    photo_upload_error: "Памылка загрузкі",
    photo_delete_error: "Не атрымалася выдаліць",
    photo_need_one: "Патрэбна хаця б адно фота",
    to_app: "У прыкладанне",
    photos_progress: "{count} з 5 фота загружана",
    discover_kicker: "Знаёмствы",
    discover_title: "Побач з табой",
    no_more_title: "Пакуль нікога побач",
    no_more_sub: "Зазірні пазней — новыя людзі з'яўляюцца кожную гадзіну.",
    refresh: "Абнавіць",
    unlock_more_photos: "Загрузі яшчэ фота, каб убачыць усе",
    stamp_like: "ЛАЙК",
    stamp_nope: "НЕ",
    daily_limit: "Дзённы ліміт лайкаў вычарпаны. Прэміум!",
    match_title: "Гэта ўзаемна!",
    match_you_liked: "{me}, вы спадабаліся {them}",
    match_you_liked_short: "Вы спадабаліся {them}",
    match_send_msg: "Напісаць паведамленне",
    match_keep: "Глядзець далей",
    matches_kicker: "Сімпатыі",
    matches_title: "Твае мэтчы",
    matches_empty_title: "Пакуль няма сімпатый",
    matches_empty_sub: "Стаў лайкі — калі ўзаемна, з'явяцца тут.",
    say_hi: "Скажы «прывітанне»",
    new_message_hint: "Новае паведамленне…",
    chat_start: "Пачніце дыялог. Скажыце «прывітанне» 👋",
    chat_input_ph: "Напішы паведамленне…",
    telegram_sent_label: "Адпраўлены Telegram",
    telegram_hidden: "Профіль схаваны",
    typing: "друкуе…",
    share_tg_title: "Адправіць свой Telegram?",
    share_tg_desc: "Суразмоўнік атрымае спасылку на ваш @{u}. Працягнуць?",
    cancel: "Скасаваць",
    send: "Адправіць",
    tg_sent_toast: "Telegram адпраўлены!",
    tg_send_error: "Не атрымалася адправіць",
    no_tg_username: "У вас няма @username у Telegram",
    profile_photos: "Фатаграфіі",
    profile_photos_count: "{n} з 5 загружана",
    profile_manage: "Кіраваць",
    profile_bio: "Пра сябе",
    profile_save: "Захаваць",
    profile_saved: "Профіль абноўлены",
    profile_photos_pill: "фота",
    profile_super_pill: "⭐ лайкі",
    profile_tier: "тарыф",
    premium_title: "Купідон Прэміум",
    premium_desc: "Безлімітныя лайкі, суперлайкі і прагляд @username мэтчаў.",
    premium_cta: "Аформіць (demo)",
    premium_activated: "Прэміум актываваны (demo)",
    logout: "Выйсці",
    error_generic: "Нешта пайшло не так. Паспрабуй яшчэ.",
    loading: "Загружаем…",
    km_short: "км",
    name_required: "Увядзіце імя",
    age_range: "Узрост 18–100",
    city_required: "Пакажыце горад",
    profile_created: "Профіль створаны!",
    hi: "Прывітанне",
    geo_unavailable: "Геалакацыя недаступная",
    geo_skip: "Працягнем без геалакацыі — уключыш пазней.",
    tg_only_or_demo: "Адкрыйце ў Telegram або выкарыстайце дэма-рэжым.",
    open_in_tg: "Адкрыць у Telegram",
    err_load_feed: "Не ўдалося загрузіць стужку",
    err_open_chat: "Не ўдалося адкрыць чат",
    err_send: "Не адправілася",
    story_title: "Гісторыя на 24 гадзіны",
    story_hint: "Адзін здымак — пакажам усім на дзень.",
    story_add: "Дадаць",
    story_active: "Актыўна яшчэ {h} гадз",
    story_uploading: "Загружаем гісторыю…",
    story_posted: "Гісторыя апублікавана!",
    story_deleted: "Гісторыя выдалена",
    story_none: "У карыстальніка няма актыўнай гісторыі",
    story_hint_video: "Фота ці кароткае відэа да 5 сек — пакажам на дзень.",
    story_video_too_long: "Відэа даўжэй за 5 сек — падрэжце і паспрабуйце зноў.",
    story_video_too_large: "Файл занадта вялікі (макс. 8 МБ).",
    profile_location_title: "Геалакацыя",
    profile_location_desc: "Тваё месцазнаходжанне бачна іншым, каб знаходзіць людзей побач.",
    profile_location_enabled: "Паказваць мяне побач",
    profile_location_update: "Абнавіць геалакацыю",
    profile_location_updated: "Геалакацыя абноўлена",
    profile_location_ask: "Дазволіць геалакацыю",
    profile_location_refreshed: "Месцазнаходжанне абноўлена пры ўваходзе",
    premium_title: "Kupidon Premium",
    premium_subtitle: "Больш увагі, больш мэтчаў",
    premium_tier_days: "{days} дзён",
    premium_buy_button: "Купіць",
    premium_current_status_free: "Бясплатны тарыф",
    premium_current_status_active: "Premium да {date}",
    premium_confirming: "Пацвярджаем аплату…",
    premium_success: "Прэміум актываваны!",
    premium_cancelled: "Аплата адменена",
    premium_failed: "Не атрымалася аплаціць. Паспрабуйце яшчэ раз",
    premium_unavailable_outside_telegram: "Аплата даступная толькі ў Telegram",
    premium_benefit_superlikes: "5 суперлайкаў у дзень",
    premium_benefit_unlimited_likes: "Лайкі без абмежаванняў",
    premium_benefit_likes_received: "Бачна, хто вас лайкнуў",
    premium_benefit_username: "Бачны юзернейм Telegram",
    premium_benefit_badge: "Прыкметны прэміум-значок",
    likes_received_kicker: "Вас лайкнулі",
    likes_received_empty: "Пакуль ніхто не лайкнуў — гэта ненадоўга",
    likes_received_like_back: "Лайкнуць у адказ",
    matches_tab_matches: "Мэтчы",
    matches_tab_likes: "Вас лайкнулі",
  },
  uz: {
    tagline_1: "O'zingning",
    tagline_hl: "«o'zaro»-ingni",
    tagline_2: "yaqindan top.",
    hero_sub: "Telegram-da tanishuvning yangi usuli. Iliq odamlar, halol fotolar.",
    continue_telegram: "Telegram orqali davom etish",
    demo_start: "Mehmon sifatida kirish",
    outside_tg: "Telegram tashqarisida ochilgan — demo-rejim mavjud.",
    onboard_title: "O'zing haqingda gapir",
    onboard_hint: "Buni boshqa foydalanuvchilar ko'radi.",
    first_name: "Ism",
    first_name_ph: "Ismingiz",
    age: "Yosh",
    i_am: "Men",
    male: "Erkak",
    female: "Ayol",
    looking_for: "Izlayapman",
    guys: "Yigitlar",
    girls: "Qizlar",
    any: "Har qanday",
    where: "Qayerdasan?",
    where_hint: "Yaqin odamlarni ko'rsatamiz.",
    country: "Davlat",
    city: "Shahar",
    city_ph: "Toshkent / Samarqand…",
    language: "Til",
    location_title: "Aniq geolokatsiya",
    location_granted: "✓ Ruxsat berildi.",
    location_ask: "Yaqinlarni ko'rish uchun ruxsat ber.",
    location_asking: "So'rov…",
    location_allow: "Ruxsat berish",
    bio_step_title: "O'zing haqingda ikki og'iz",
    bio_step_hint: "Qisqa va yurakdan. 300 belgigacha.",
    bio_ph: "Masalan: sayohat, kofe, kitob…",
    next: "Keyingi",
    finish: "Tayyor",
    saving: "Saqlaymiz…",
    step_photos_kicker: "2-qadam",
    photos_title: "Sening fotolaring",
    photos_hint_a: "1–5 foto yukla. Qancha ko'p bo'lsa, boshqalarnikini shuncha ",
    photos_hint_b: "xiralashsiz ko'rasan.",
    photos_max: "Maksimum 5 foto",
    photo_add: "Qo'shish",
    photo_uploading: "Yuklanmoqda…",
    photo_main: "Asosiy",
    upload_toast: "Yuklab tekshirmoqdamiz…",
    photo_added: "Foto qo'shildi!",
    photo_upload_error: "Yuklash xatosi",
    photo_delete_error: "O'chirib bo'lmadi",
    photo_need_one: "Kamida bitta foto kerak",
    to_app: "Ilovaga",
    photos_progress: "5 dan {count} ta foto yuklandi",
    discover_kicker: "Tanishuv",
    discover_title: "Sening yoningda",
    no_more_title: "Hozircha yaqinda hech kim yo'q",
    no_more_sub: "Keyinroq kel — yangi odamlar paydo bo'ladi.",
    refresh: "Yangilash",
    unlock_more_photos: "Barchasini ko'rish uchun yana foto yukla",
    stamp_like: "LIKE",
    stamp_nope: "YO'Q",
    daily_limit: "Kunlik like limiti tugadi. Premium!",
    match_title: "O'zaro!",
    match_you_liked: "{me}, siz {them} ga yoqdingiz",
    match_you_liked_short: "Siz {them} ga yoqdingiz",
    match_send_msg: "Xabar yozish",
    match_keep: "Davom etish",
    matches_kicker: "Simpatiyalar",
    matches_title: "Sening match-laring",
    matches_empty_title: "Hozircha simpatiya yo'q",
    matches_empty_sub: "Like qo'y — o'zaro bo'lsa shu yerda paydo bo'ladi.",
    say_hi: "«Salom» de",
    new_message_hint: "Yangi xabar…",
    chat_start: "Muloqotni boshla. «Salom» deb yoz 👋",
    chat_input_ph: "Xabar yoz…",
    telegram_sent_label: "Telegram yuborildi",
    telegram_hidden: "Profil yashirin",
    typing: "yozmoqda…",
    share_tg_title: "O'z Telegram-ingni yuborasanmi?",
    share_tg_desc: "U sizning @{u} havolangizni oladi. Davom etamizmi?",
    cancel: "Bekor qilish",
    send: "Yuborish",
    tg_sent_toast: "Telegram yuborildi!",
    tg_send_error: "Yuborilmadi",
    no_tg_username: "Sizda Telegram @username yo'q",
    profile_photos: "Fotolar",
    profile_photos_count: "5 dan {n} ta yuklandi",
    profile_manage: "Boshqarish",
    profile_bio: "O'zim haqimda",
    profile_save: "Saqlash",
    profile_saved: "Profil yangilandi",
    profile_photos_pill: "foto",
    profile_super_pill: "⭐ like",
    profile_tier: "tarif",
    premium_title: "Kupidon Premium",
    premium_desc: "Cheksiz like, superlike va match-lar @username.",
    premium_cta: "Rasmiylashtirish (demo)",
    premium_activated: "Premium faollashtirildi (demo)",
    logout: "Chiqish",
    error_generic: "Nimadir noto'g'ri ketdi. Qayta urinib ko'r.",
    loading: "Yuklanmoqda…",
    km_short: "km",
    name_required: "Ismingizni kiriting",
    age_range: "Yosh 18–100",
    city_required: "Shaharni ko'rsating",
    profile_created: "Profil yaratildi!",
    hi: "Salom",
    geo_unavailable: "Geolokatsiya mavjud emas",
    geo_skip: "Geolokatsiyasiz davom etamiz — keyin yoqishingiz mumkin.",
    tg_only_or_demo: "Telegram ichida oching yoki demo-rejimdan foydalaning.",
    open_in_tg: "Telegram-da ochish",
    err_load_feed: "Lentani yuklab bo'lmadi",
    err_open_chat: "Chatni ochib bo'lmadi",
    err_send: "Yuborilmadi",
    story_title: "24 soatlik hikoya",
    story_hint: "Bitta surat — bir kunga hammaga ko'rsatamiz.",
    story_add: "Qo'shish",
    story_active: "Yana {h} soat faol",
    story_uploading: "Hikoyani yuklamoqdamiz…",
    story_posted: "Hikoya joylandi!",
    story_deleted: "Hikoya o'chirildi",
    story_none: "Foydalanuvchida faol hikoya yo'q",
    story_hint_video: "Foto yoki 5 soniyagacha video — bir kunga ko'rsatamiz.",
    story_video_too_long: "Video 5 soniyadan uzun — qisqartiring va qayta urinib ko'ring.",
    story_video_too_large: "Fayl juda katta (maks. 8 MB).",
    profile_location_title: "Geolokatsiya",
    profile_location_desc: "Sizning joylashuvingiz boshqalarga ko'rinadi, yaqin odamlarni topish uchun.",
    profile_location_enabled: "Meni yaqindan ko'rsatish",
    profile_location_update: "Geolokatsiyani yangilash",
    profile_location_updated: "Geolokatsiya yangilandi",
    profile_location_ask: "Geolokatsiyaga ruxsat berish",
    profile_location_refreshed: "Joylashuv kirishda yangilandi",
    premium_title: "Kupidon Premium",
    premium_subtitle: "Ko'proq e'tibor, ko'proq match",
    premium_tier_days: "{days} kun",
    premium_buy_button: "Sotib olish",
    premium_current_status_free: "Bepul tarif",
    premium_current_status_active: "Premium {date} gacha",
    premium_confirming: "To'lov tasdiqlanmoqda…",
    premium_success: "Premium faollashtirildi!",
    premium_cancelled: "To'lov bekor qilindi",
    premium_failed: "To'lov amalga oshmadi. Qayta urinib ko'ring",
    premium_unavailable_outside_telegram: "To'lov faqat Telegram-da mavjud",
    premium_benefit_superlikes: "Kuniga 5 ta superlayk",
    premium_benefit_unlimited_likes: "Cheklovsiz like-lar",
    premium_benefit_likes_received: "Sizni kim like qilganini ko'rish",
    premium_benefit_username: "Telegram username ko'rinadi",
    premium_benefit_badge: "Ajralib turuvchi premium belgisi",
    likes_received_kicker: "Sizni like qilganlar",
    likes_received_empty: "Hozircha hech kim like qilmagan — bu uzoqqa cho'zilmaydi",
    likes_received_like_back: "Javob like qilish",
    matches_tab_matches: "Match-lar",
    matches_tab_likes: "Sizni like qilganlar",
  },
  ky: {
    tagline_1: "Өз",
    tagline_hl: "«өз ара»",
    tagline_2: "жакындан тап.",
    hero_sub: "Telegram'де тааныштыктын жаңы жолу. Жылуу адамдар, чын сүрөттөр.",
    continue_telegram: "Telegram аркылуу улантуу",
    demo_start: "Конок катары кирүү",
    outside_tg: "Telegram сыртында — демо-режим жеткиликтүү.",
    onboard_title: "Өзүң жөнүндө айт",
    onboard_hint: "Муну башка колдонуучулар көрөт.",
    first_name: "Аты",
    first_name_ph: "Атыңыз",
    age: "Жашы",
    i_am: "Мен",
    male: "Эркек",
    female: "Аял",
    looking_for: "Издейм",
    guys: "Жигиттерди",
    girls: "Кыздарды",
    any: "Каалагандай",
    where: "Кайдасың?",
    where_hint: "Жаныңдагы адамдарды көрсөтөбүз.",
    country: "Өлкө",
    city: "Шаар",
    city_ph: "Бишкек / Ош…",
    language: "Тил",
    location_title: "Так геолокация",
    location_granted: "✓ Уруксат берилди.",
    location_ask: "Жакындагыларды көрүү үчүн уруксат бер.",
    location_asking: "Суроо…",
    location_allow: "Уруксат берүү",
    bio_step_title: "Өзүң жөнүндө эки ооз",
    bio_step_hint: "Кыска жана жүрөктөн. 300 белгиге чейин.",
    bio_ph: "Мисалы: саякат, кофе, китеп…",
    next: "Кийинки",
    finish: "Даяр",
    saving: "Сактап жатабыз…",
    step_photos_kicker: "2-кадам",
    photos_title: "Сенин сүрөттөрүң",
    photos_hint_a: "1–5 сүрөт жүктө. Канчалык көп болсо, башкалардыкын ",
    photos_hint_b: "бүдөмүксүз көрөсүң.",
    photos_max: "Максимум 5 сүрөт",
    photo_add: "Кошуу",
    photo_uploading: "Жүктөлүүдө…",
    photo_main: "Башкы",
    upload_toast: "Жүктөп текшерип жатабыз…",
    photo_added: "Сүрөт кошулду!",
    photo_upload_error: "Жүктөө катасы",
    photo_delete_error: "Өчүрүлбөдү",
    photo_need_one: "Жок дегенде бир сүрөт керек",
    to_app: "Колдонмого",
    photos_progress: "5тен {count} сүрөт жүктөлдү",
    discover_kicker: "Тааныштык",
    discover_title: "Сенин жаныңда",
    no_more_title: "Азырынча жанда эч ким жок",
    no_more_sub: "Кийинчерээк кайра кел.",
    refresh: "Жаңылоо",
    unlock_more_photos: "Баарын көрүү үчүн дагы сүрөт жүктө",
    stamp_like: "ЛАЙК",
    stamp_nope: "ЖОК",
    daily_limit: "Күндөлүк лайк лимити бүттү. Премиум!",
    match_title: "Өз ара!",
    match_you_liked: "{me}, {them} сени жактырды",
    match_you_liked_short: "{them} сени жактырды",
    match_send_msg: "Билдирүү жазуу",
    match_keep: "Улантуу",
    matches_kicker: "Симпатиялар",
    matches_title: "Сенин мэтчтериң",
    matches_empty_title: "Азырынча симпатия жок",
    matches_empty_sub: "Лайк кой — өз ара болгондо бул жерде пайда болот.",
    say_hi: "«Салам» де",
    new_message_hint: "Жаңы билдирүү…",
    chat_start: "Маекти башта. «Салам» деп жаз 👋",
    chat_input_ph: "Билдирүү жаз…",
    telegram_sent_label: "Telegram жиберилди",
    telegram_hidden: "Профиль жашырылган",
    typing: "жазып жатат…",
    share_tg_title: "Өзүңдүн Telegram'иңди жиберүү?",
    share_tg_desc: "Ал сенин @{u} шилтемеңди алат. Улантабызбы?",
    cancel: "Жокко чыгаруу",
    send: "Жиберүү",
    tg_sent_toast: "Telegram жиберилди!",
    tg_send_error: "Жиберилген жок",
    no_tg_username: "Telegram'де @username жок",
    profile_photos: "Сүрөттөр",
    profile_photos_count: "5тен {n} жүктөлдү",
    profile_manage: "Башкаруу",
    profile_bio: "Өзүм жөнүндө",
    profile_save: "Сактоо",
    profile_saved: "Профиль жаңыртылды",
    profile_photos_pill: "сүрөт",
    profile_super_pill: "⭐ лайк",
    profile_tier: "тариф",
    premium_title: "Купидон Премиум",
    premium_desc: "Чексиз лайк, суперлайк жана мэтчтердин @username.",
    premium_cta: "Каттоо (demo)",
    premium_activated: "Премиум иштетилди (demo)",
    logout: "Чыгуу",
    error_generic: "Ката кетти. Кайра аракет кыл.",
    loading: "Жүктөлүүдө…",
    km_short: "км",
    name_required: "Атыңды жаз",
    age_range: "Жашы 18–100",
    city_required: "Шаарды көрсөт",
    profile_created: "Профиль түзүлдү!",
    hi: "Салам",
    geo_unavailable: "Геолокация жеткиликсиз",
    geo_skip: "Геолокациясыз улантабыз — кийин кошсоң болот.",
    tg_only_or_demo: "Telegram ичинде ач же демо-режимди колдон.",
    open_in_tg: "Telegram'де ачуу",
    err_load_feed: "Лентаны жүктөө мүмкүн болбоду",
    err_open_chat: "Чатты ачуу мүмкүн болбоду",
    err_send: "Жиберилген жок",
    story_title: "24 сааттык стори",
    story_hint: "Бир сүрөт — бир күнгө баарына көрсөтөбүз.",
    story_add: "Кошуу",
    story_active: "Дагы {h} саат активдүү",
    story_uploading: "Сторини жүктөп жатабыз…",
    story_posted: "Стори жарыяланды!",
    story_deleted: "Стори өчүрүлдү",
    story_none: "Колдонуучуда активдүү стори жок",
    story_hint_video: "Сүрөт же 5 секундга чейинки видео — бир күнгө көрсөтөбүз.",
    story_video_too_long: "Видео 5 секунддан узун — кыскартып, кайра аракет кыл.",
    story_video_too_large: "Файл өтө чоң (макс. 8 МБ).",
    profile_location_title: "Геолокация",
    profile_location_desc: "Сиздин жайгашууңуз башкаларга көрүнөт, жакын адамдарды табуу үчүн.",
    profile_location_enabled: "Мени жакындан көрсөтүү",
    profile_location_update: "Геолокацияны жаңыртуу",
    profile_location_updated: "Геолокация жаңыртылды",
    profile_location_ask: "Геолокацияга уруксат берүү",
    profile_location_refreshed: "Жайгашуу кирүүдө жаңыртылды",
    premium_title: "Kupidon Premium",
    premium_subtitle: "Көбүрөөк көңүл, көбүрөөк мэтч",
    premium_tier_days: "{days} күн",
    premium_buy_button: "Сатып алуу",
    premium_current_status_free: "Акысыз тариф",
    premium_current_status_active: "Premium {date} чейин",
    premium_confirming: "Төлөм ырасталууда…",
    premium_success: "Премиум иштетилди!",
    premium_cancelled: "Төлөм жокко чыгарылды",
    premium_failed: "Төлөм өтпөй калды. Кайра аракет кылыңыз",
    premium_unavailable_outside_telegram: "Төлөм жалгыз Telegram'де жеткиликтүү",
    premium_benefit_superlikes: "Күнүнө 5 суперлайк",
    premium_benefit_unlimited_likes: "Чексиз лайктар",
    premium_benefit_likes_received: "Сизди ким лайк баскан көрүнөт",
    premium_benefit_username: "Telegram юзернейми көрүнөт",
    premium_benefit_badge: "Көрүнүктүү премиум белгиси",
    likes_received_kicker: "Сизди лайк баскандар",
    likes_received_empty: "Азырынча эч ким лайк баскан жок — бул узакка созулбайт",
    likes_received_like_back: "Жооп лайк басуу",
    matches_tab_matches: "Мэтчтер",
    matches_tab_likes: "Сизди лайк баскандар",
  },
};

export const DEFAULT_LANG = "ru";

export function t(lang, key, vars = {}) {
  const dict = D[lang] || D.ru;
  let s = dict[key];
  if (s === undefined) s = D.ru[key];
  if (s === undefined) s = key;
  Object.entries(vars).forEach(([k, v]) => {
    s = s.replaceAll(`{${k}}`, String(v));
  });
  return s;
}
